"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NextPage = require("./NextPage/NextPage");
var _Numbers = require("./Numbers/Numbers");
var _PreviousPage = require("./PreviousPage/PreviousPage");
require("./Pagination.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Pagination = function Pagination(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? 1 : _ref$total,
    _ref$current = _ref.current,
    current = _ref$current === void 0 ? 1 : _ref$current,
    _ref$surrounding = _ref.surrounding,
    surrounding = _ref$surrounding === void 0 ? 2 : _ref$surrounding,
    _ref$arePrevAndNextSh = _ref.arePrevAndNextShown,
    arePrevAndNextShown = _ref$arePrevAndNextSh === void 0 ? true : _ref$arePrevAndNextSh,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      previousPage: 'previous page',
      nextPage: 'next page'
    } : _ref$text;
  var PreviousPage = Pagination.PreviousPage,
    Numbers = Pagination.Numbers,
    NextPage = Pagination.NextPage;
  var effectiveCurrent = (0, _react.useMemo)(function () {
    if (!current || current < 1) {
      return 1;
    }
    if (current > total) {
      return total;
    }
    return current;
  }, [current, total]);
  if (total <= 1) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-Pagination', className)
  }, arePrevAndNextShown && /*#__PURE__*/_react["default"].createElement(PreviousPage, {
    current: effectiveCurrent,
    onClick: onClick,
    text: text
  }), /*#__PURE__*/_react["default"].createElement(Numbers, {
    total: total,
    current: effectiveCurrent,
    surrounding: surrounding,
    onClick: onClick
  }), arePrevAndNextShown && /*#__PURE__*/_react["default"].createElement(NextPage, {
    total: total,
    current: effectiveCurrent,
    onClick: onClick,
    text: text
  }));
};
exports.Pagination = Pagination;
Pagination.Numbers = _Numbers.Numbers;
Pagination.NextPage = _NextPage.NextPage;
Pagination.PreviousPage = _PreviousPage.PreviousPage;